module.exports = __webpack_public_path__ + "static/media/ZUT.ef6c3cd1.pdf";